import React from 'react'
import Modal from '../../../components/Modal'
import CustomSelect from '../../../components/CustomSelect/CustomSelect'
import DateRangeFilter from '../../../components/DateRangeFilter'

export default function OperationFormModal({
  showModal,
  setShowModal,
  showAddMenu,
  setShowAddMenu,
  activeActionType,
  editingId,
  formData,
  setFormData,
  confirmData,
  setConfirmData,
  saving,
  quickAddContext,
  setQuickAddContext,
  quickAddSelectedTypes,
  setQuickAddSelectedTypes,
  shiftMarkers,
  employees,
  customRules,
  canAddForOthers,
  profile,
  isAdmin,
  userPermissions,
  getTypeInfo,
  baseActions,
  handleOpenAction,
  handleDismissShift,
  handleQuickAdd,
  handlePreSubmit,
  handleSubmit,
  today,
  selectedPvzIds,
  userPvzs
}) {
  return (
    <>
      {/* Модалка выбора типа операции */}
      <Modal 
        isOpen={showAddMenu} 
        onClose={() => { setShowAddMenu(false); setQuickAddContext(null) }} 
        title={quickAddContext ? 'Быстрый ввод' : 'Выберите тип операции'} 
        isBottomSheet={true}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', padding: '8px 0 16px' }}>
          {quickAddContext && (
            <div style={{
              background: 'linear-gradient(135deg, rgba(203,17,171,0.06), rgba(147,51,234,0.06))',
              border: '1px solid rgba(203,17,171,0.2)',
              borderRadius: '12px', padding: '12px 16px', marginBottom: '4px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ fontSize: '14px', fontWeight: 700 }}>{quickAddContext.empName}</div>
                <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>{quickAddContext.dateFormatted}</div>
              </div>
            </div>
          )}

          {quickAddContext ? (() => {
            const marker = shiftMarkers?.[quickAddContext.date]?.find(m => m.id === quickAddContext.employeeId)
            const missing = marker?.missingTypes || []
            const opInfo = {
              acceptance: { icon: <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg></>, title: 'Приёмка', color: '#14B8A6', desc: 'Зафиксировать принятые' },
              issued: { icon: <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg></>, title: 'Выдача', color: '#10B981', desc: 'Записать выданные' },
              returns: { icon: <><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg></>, title: 'Возврат', color: '#3B82F6', desc: 'Оформить возвраты' }
            }
            if (missing.length === 0) return (
              <div style={{ textAlign: 'center', padding: '20px', color: 'var(--text-secondary)' }}>
                <div style={{ fontSize: '40px', marginBottom: '8px' }}><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>
                <div style={{ fontWeight: 600 }}>Все операции внесены!</div>
                <button type="button" onClick={() => { setShowAddMenu(false); setQuickAddContext(null) }}
                  style={{ marginTop: '12px', padding: '10px 24px', borderRadius: '10px', border: 'none', background: 'var(--wb-primary)', color: 'white', fontWeight: 600, cursor: 'pointer' }}>Готово</button>
              </div>
            )
            return (<>
              <div style={{ fontSize: '12px', color: 'var(--text-tertiary)', fontWeight: 600, marginBottom: '2px' }}>Не внесено ({missing.length}):</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {missing.map(type => {
                  const info = opInfo[type]; if (!info) return null
                  const isChecked = quickAddSelectedTypes.includes(type)
                  const toggleCheck = () => {
                    setQuickAddSelectedTypes(prev =>
                      prev.includes(type) ? prev.filter(t => t !== type) : [...prev, type]
                    )
                  }
                  return (
                    <div key={type} style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '4px 8px' }} onClick={(e) => e.stopPropagation()}>
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={toggleCheck}
                          style={{ width: '20px', height: '20px', accentColor: 'var(--wb-primary)', cursor: 'pointer' }}
                        />
                      </label>
                      <button type="button" onClick={() => { handleOpenAction(type); setShowAddMenu(false) }}
                        style={{ flex: 1, padding: '12px 16px', border: 'none', borderRadius: '14px', cursor: 'pointer',
                          background: `color-mix(in srgb, ${info.color} 8%, transparent)`,
                          display: 'flex', alignItems: 'center', gap: '12px', textAlign: 'left', transition: 'all 0.2s' }}>
                        <span style={{ fontSize: '20px', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '10px', background: `color-mix(in srgb, ${info.color} 15%, transparent)` }}>{info.icon}</span>
                        <div>
                          <div style={{ fontWeight: 700, fontSize: '14px', color: info.color }}>{info.title}</div>
                          <div style={{ fontSize: '11px', color: 'var(--text-tertiary)' }}>{info.desc}</div>
                        </div>
                      </button>
                      <button type="button" onClick={() => handleDismissShift(quickAddContext.date, quickAddContext.employeeId, type)}
                        title="Пропустить эту операцию" style={{ width: '44px', height: '60px', border: '1px dashed var(--surface-border)', borderRadius: '14px', cursor: 'pointer',
                          background: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', flexShrink: 0, color: 'var(--text-tertiary)', transition: 'all 0.15s' }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 4 15 12 5 20 5 4"/><line x1="19" y1="5" x2="19" y2="19"/></svg>
                      </button>
                    </div>
                  )
                })}
              </div>

              {/* Кнопки массового пропуска */}
              <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  disabled={quickAddSelectedTypes.length === 0}
                  onClick={() => {
                    quickAddSelectedTypes.forEach(t => {
                      handleDismissShift(quickAddContext.date, quickAddContext.employeeId, t)
                    })
                    setQuickAddSelectedTypes([])
                    const marker = shiftMarkers?.[quickAddContext.date]?.find(m => m.id === quickAddContext.employeeId)
                    const remaining = (marker?.missingTypes || []).filter(t => !quickAddSelectedTypes.includes(t))
                    if (remaining.length === 0) {
                      setShowAddMenu(false)
                      setQuickAddContext(null)
                    }
                  }}
                  style={{ flex: 1, fontSize: '13px', padding: '12px' }}
                >
                  Пропустить выбранные ({quickAddSelectedTypes.length})
                </button>
                
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    missing.forEach(t => {
                      handleDismissShift(quickAddContext.date, quickAddContext.employeeId, t)
                    })
                    setShowAddMenu(false)
                    setQuickAddContext(null)
                  }}
                  style={{ flex: 1, fontSize: '13px', padding: '12px', background: 'var(--wb-primary)', borderColor: 'var(--wb-primary)' }}
                >
                  Пропустить все ({missing.length})
                </button>
              </div>
            </>)
          })() : (<>
            {baseActions.map(action => (
              <button type="button" key={action.id} onClick={() => { handleOpenAction(action.id); setShowAddMenu(false) }}
                style={{ padding: '16px 20px', border: 'none', borderRadius: '14px', cursor: 'pointer',
                  background: `color-mix(in srgb, ${action.color} 8%, transparent)`,
                  display: 'flex', alignItems: 'center', gap: '14px', transition: 'all 0.2s', textAlign: 'left' }}>
                <span style={{ fontSize: '28px', width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '12px', background: `color-mix(in srgb, ${action.color} 15%, transparent)` }}>{action.icon}</span>
                <div>
                  <div style={{ fontWeight: 700, fontSize: '16px', color: action.color }}>{action.title}</div>
                  <div style={{ fontSize: '13px', color: 'var(--text-tertiary)', marginTop: '2px' }}>
                    {action.id === 'acceptance' && 'Зафиксировать принятые товары'}
                    {action.id === 'issued' && 'Записать выданные заказы'}
                    {action.id === 'returns' && 'Оформить возврат товаров'}
                  </div>
                </div>
              </button>
            ))}
            {isAdmin && (
              <button type="button" onClick={() => { handleOpenAction('expense_var'); setShowAddMenu(false) }}
                style={{ padding: '16px 20px', border: 'none', borderRadius: '14px', cursor: 'pointer',
                  background: 'color-mix(in srgb, var(--danger) 8%, transparent)',
                  display: 'flex', alignItems: 'center', gap: '14px', transition: 'all 0.2s', textAlign: 'left' }}>
                <span style={{ fontSize: '28px', width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '12px', background: 'color-mix(in srgb, var(--danger) 15%, transparent)' }}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2"/><path d="M6 12h.01M18 12h.01"/></svg></span>
                <div>
                  <div style={{ fontWeight: 700, fontSize: '16px', color: 'var(--danger)' }}>Расходник</div>
                  <div style={{ fontSize: '13px', color: 'var(--text-tertiary)', marginTop: '2px' }}>Учет затрат</div>
                </div>
              </button>
            )}
            {customRules.map(rule => (
              <button type="button" key={rule.id} onClick={() => { handleOpenAction('custom', rule.id); setShowAddMenu(false) }}
                style={{ padding: '16px 20px', border: 'none', borderRadius: '14px', cursor: 'pointer',
                  background: 'color-mix(in srgb, var(--warning) 8%, transparent)',
                  display: 'flex', alignItems: 'center', gap: '14px', transition: 'all 0.2s', textAlign: 'left' }}>
                <span style={{ fontSize: '28px', width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '12px', background: 'color-mix(in srgb, var(--warning) 15%, transparent)' }}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg></span>
                <div>
                  <div style={{ fontWeight: 700, fontSize: '16px', color: 'var(--warning)' }}>{rule.name}</div>
                  <div style={{ fontSize: '13px', color: 'var(--text-tertiary)', marginTop: '2px' }}>Дополнительная операция</div>
                </div>
              </button>
            ))}
          </>)}
        </div>
      </Modal>

      {/* Модалка добавления / редактирования */}
      <Modal 
        isOpen={showModal} 
        onClose={() => { setShowModal(false); setQuickAddContext(null) }} 
        title={editingId ? 'Редактировать запись' : getTypeInfo(activeActionType === 'custom' ? `custom:${formData.customRuleId}` : activeActionType).title} 
        isBottomSheet={true}
        data-tour="operations-form"
      >
        <form className="operations-form" onSubmit={handlePreSubmit}>
          {/* Контекст быстрого ввода в форме */}
          {quickAddContext && !editingId && (
            <div style={{
              background: 'linear-gradient(135deg, rgba(203,17,171,0.06), rgba(147,51,234,0.06))',
              border: '1px solid rgba(203,17,171,0.2)',
              borderRadius: '12px',
              padding: '10px 14px',
              marginBottom: '8px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px' }}>
                <span style={{ fontWeight: 700 }}>{quickAddContext.empName}</span>
                <span style={{ color: 'var(--text-tertiary)' }}>•</span>
                <span>{quickAddContext.dateFormatted}</span>
              </div>
              {quickAddContext.missingLabels?.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px' }}>
                  <span style={{ fontSize: '10px', color: 'var(--text-tertiary)', fontWeight: 600 }}>Нет:</span>
                  {quickAddContext.missingLabels.map((label, i) => (
                    <span key={i} style={{
                      fontSize: '10px', fontWeight: 600, padding: '1px 6px',
                      borderRadius: '4px', background: 'rgba(239,68,68,0.12)', color: '#DC2626'
                    }}>{label}</span>
                  ))}
                </div>
              )}
            </div>
          )}
          {canAddForOthers && (
            <div className="input-group">
              <CustomSelect
                label="Сотрудник"
                value={formData.employeeId}
                onChange={val => setFormData({...formData, employeeId: val})}
                placeholder="Выберите сотрудника"
                options={employees.filter(e => !e.is_legacy).map(emp => ({
                  value: emp.id,
                  label: emp.name,
                }))}
              />
            </div>
          )}
          {selectedPvzIds && selectedPvzIds.length > 1 && (
            <div className="input-group">
              <CustomSelect
                label="Пункт выдачи"
                value={formData.pvzId}
                onChange={val => setFormData({...formData, pvzId: val})}
                placeholder="Выберите ПВЗ"
                options={(userPvzs || []).filter(p => selectedPvzIds.includes(p.id)).map(pvz => ({
                  value: pvz.id,
                  label: pvz.name,
                }))}
              />
            </div>
          )}
          <div className="input-group">
            <label>Дата</label>
            <DateRangeFilter 
              startDate={formData.date} 
              endDate={formData.date} 
              isSingleDate={true}
              onApply={(start) => setFormData({...formData, date: start})}
              onReset={() => setFormData({...formData, date: today()})}
              shiftMarkers={shiftMarkers}
              onBadgeClick={handleQuickAdd}
            />
          </div>

          {activeActionType === 'returns' ? (
            <>
              <div className="input-group">
                <label>Штрихкод коробки (впишите или отсканируйте)</label>
                <input className="input" autoFocus type="text" placeholder="Например: WBR123..." value={formData.boxNumber} onChange={e => setFormData({...formData, boxNumber: e.target.value})} required />
              </div>
              <div className="input-group">
                <label>Количество товаров (шт)</label>
                <input className="input" type="number" step="1" min="1" placeholder="0" value={formData.count === 0 || formData.count === '0' ? '' : formData.count} onChange={e => setFormData({...formData, count: e.target.value})} required />
              </div>
              <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
                <div className="input-group" style={{ flex: 1 }}>
                  <label>Начало пересчёта</label>
                  <input className="input" type="time" value={formData.startTime || ''} onChange={e => setFormData({...formData, startTime: e.target.value})} />
                </div>
                <div className="input-group" style={{ flex: 1 }}>
                  <label>Окончание</label>
                  <input className="input" type="time" value={formData.endTime || ''} onChange={e => setFormData({...formData, endTime: e.target.value})} />
                </div>
              </div>
            </>
          ) : activeActionType === 'acceptance' ? (
            <div style={{ display: 'flex', gap: '12px' }}>
              <div className="input-group" style={{ flex: 1 }}>
                <label>Вовремя (шт)</label>
                <input 
                  className="input" autoFocus type="number" step="1" min="0" placeholder="0" 
                  value={formData.count === 0 || formData.count === '0' ? '' : formData.count} 
                  onChange={e => setFormData({...formData, count: e.target.value})} 
                />
              </div>
              <div className="input-group" style={{ flex: 1 }}>
                <label>С опозданием (шт)</label>
                <input 
                  className="input" type="number" step="1" min="0" placeholder="0" 
                  value={formData.countLate === 0 || formData.countLate === '0' ? '' : formData.countLate} 
                  onChange={e => setFormData({...formData, countLate: e.target.value})} 
                />
              </div>
            </div>
          ) : activeActionType === 'expense_var' ? (
            <>
              <div className="input-group" style={{ marginBottom: '12px' }}>
                <label>Категория/Товар</label>
                <input className="input" autoFocus type="text" placeholder="Например: Пакеты, Скотч, Бумага" value={formData.boxNumber} onChange={e => setFormData({...formData, boxNumber: e.target.value})} required />
              </div>
              <div style={{ display: 'flex', gap: '12px' }}>
                <div className="input-group" style={{ flex: 1 }}>
                  <label>Сумма расхода (₽)</label>
                  <input className="input" type="number" step="1" min="0" placeholder="0" value={formData.count === 0 || formData.count === '0' ? '' : formData.count} onChange={e => setFormData({...formData, count: e.target.value})} required />
                </div>
                <div className="input-group" style={{ flex: 1 }}>
                  <label>Количество (шт)</label>
                  <input className="input" type="number" step="1" min="1" placeholder="0" value={formData.countLate === 0 || formData.countLate === '0' ? '' : formData.countLate} onChange={e => setFormData({...formData, countLate: e.target.value})} />
                </div>
              </div>
            </>
          ) : (
            <div className="input-group">
              <label>
                {activeActionType === 'custom' && getTypeInfo(`custom:${formData.customRuleId}`).rule?.type === 'percent' ? 'Сумма (₽)' : 'Количество (шт)'}
              </label>
              <input className="input" autoFocus type="number" step="0.1" min="0" placeholder="0" value={formData.count === 0 || formData.count === '0' ? '' : formData.count} onChange={e => setFormData({...formData, count: e.target.value})} />
            </div>
          )}

          <div className="input-group">
            <label>Комментарий (необязательно)</label>
            <input className="input" type="text" placeholder="Заметка..." value={formData.comment} onChange={e => setFormData({...formData, comment: e.target.value})} />
          </div>

          {editingId && !isAdmin && (
            <div className="input-group" style={{ marginTop: '12px' }}>
              <label style={{ color: '#b45309', fontWeight: 600 }}>Причина изменения (если смена закрыта)</label>
              <input
                className="input"
                type="text"
                placeholder="Например: Ошибочно ввела 0 вместо 3"
                value={formData.reason || ''}
                onChange={e => setFormData({...formData, reason: e.target.value})}
              />
            </div>
          )}

          <div style={{ marginTop: '24px', display: 'flex', gap: '10px' }}>
            {quickAddContext && !editingId && (
              <button type="button" className="btn btn-secondary" style={{ flex: 0, padding: '12px 16px', whiteSpace: 'nowrap' }}
                onClick={() => { setShowModal(false); setShowAddMenu(true) }}>
                ← Назад
              </button>
            )}
            <button type="submit" className="btn btn-primary" style={{ flex: 1 }} disabled={saving}>
              {saving ? 'Сохранение...' : (editingId ? (isAdmin ? 'Сохранить изменения' : 'Сохранить / Запросить') : 'Добавить')}
            </button>
          </div>
        </form>
      </Modal>

      {/* Модалка подтверждения сохранения */}
      <Modal isOpen={confirmData} onClose={() => setConfirmData(false)} title="Подтверждение данных" isBottomSheet={true} onConfirm={handleSubmit}>
        <div style={{ padding: '10px 0 24px 0', color: 'var(--text-secondary)' }}>
          {editingId && !isAdmin ? (
            <span>
              В вашей <strong>открытой смене</strong> изменение применится сразу. Если смена уже закрыта, будет создан запрос на рассмотрение управляющему.
            </span>
          ) : (
            <span>
              Уверены ли вы в внесенных данных? В открытой смене вы сможете отредактировать запись прямо во время работы.
            </span>
          )}
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button type="button" className="btn btn-ghost" style={{ flex: 1 }} onClick={() => setConfirmData(false)}>
            Проверить еще раз
          </button>
          <button type="button" className="btn btn-primary" style={{ flex: 1 }} onClick={handleSubmit}>
            Да, сохранить
          </button>
        </div>
      </Modal>
    </>
  )
}
